import React, { useEffect, useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { getTenantDisplayName } from '../tenantHelpers';

const FaultTenantModal = ({ tenant, isOpen, onClose, onConfirm, isSaving, error }) => {
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (isOpen) setReason('');
  }, [isOpen, tenant?.id]);

  if (!isOpen || !tenant) return null;

  const bookedBy = tenant.currentBooking?.bookedUserName || tenant.currentBooking?.bookedBy;

  const resetAndClose = () => {
    setReason('');
    onClose();
  };

  return (
    <div className="stm-modal-overlay" onClick={resetAndClose}>
      <div className="stm-modal stm-modal--sm" onClick={(event) => event.stopPropagation()}>
        <header className="stm-modal__header">
          <div>
            <h2>Mark as faulted</h2>
            <p>{getTenantDisplayName(tenant)}</p>
          </div>
          <button type="button" className="stm-icon-btn" onClick={resetAndClose} disabled={isSaving} aria-label="Close">
            <FaTimes />
          </button>
        </header>
        <div className="stm-modal__body">
          <p className="stm-modal__text">
            Mark {getTenantDisplayName(tenant)} as faulted?
          </p>
          {bookedBy && (
            <p className="stm-modal__text stm-muted">
              {bookedBy} currently has this tenant booked.
            </p>
          )}
          <p className="stm-modal__text stm-muted">
            The tenant will be marked as faulted and should not be reused until the issue is resolved.
          </p>
          <label className="stm-field">
            <span className="stm-field__label">Reason (optional)</span>
            <textarea value={reason} onChange={(event) => setReason(event.target.value)} rows={3} disabled={isSaving} />
          </label>
          {error && <p className="stm-field-error">{error}</p>}
        </div>
        <footer className="stm-modal__footer">
          <button type="button" className="stm-btn stm-btn--secondary" onClick={resetAndClose} disabled={isSaving}>Cancel</button>
          <button type="button" className="stm-btn stm-btn--primary" disabled={isSaving} onClick={() => onConfirm(reason)}>
            {isSaving ? 'Working...' : 'Mark as Faulted'}
          </button>
        </footer>
      </div>
    </div>
  );
};

export default FaultTenantModal;
